import { __ } from '@/hub-shared/utils/i18n';

/**
 * Canonical profile observation keys a connection can import (aligned with backend mappers, e.g. PennylaneProfileObservationMapper).
 */
const PENNYLANE_FIELD_IDS: readonly string[] = [
  'identity.legal_name',
  'identity.siren',
  'identity.siret',
  'identity.vat_number',
  'identity.legal_form',
  'identity.nace_codes',
  'contact.email',
  'contact.phone',
  'address.headquarters.line1',
  'address.headquarters.line2',
  'address.headquarters.postal_code',
  'address.headquarters.city',
  'address.headquarters.country',
  'fiscal.year_start',
  'fiscal.year_end',
];

const DEV_MOCK_PROVIDER_FIELD_IDS: readonly string[] = [
  'identity.legal_name',
  'identity.siren',
  'identity.legal_form',
];

const DEV_MOCK_PROVIDER_ALT_FIELD_IDS: readonly string[] = [
  'identity.legal_name',
  'contact.email',
];

const DEV_MOCK_PROVIDER_NO_SIREN_FIELD_IDS: readonly string[] = [
  'identity.legal_name',
  'identity.nace_codes',
  'identity.legal_form',
];

const FIELDS_BY_CONNECTION_ID: Record<string, readonly string[]> = {
  pennylane: PENNYLANE_FIELD_IDS,
  'dev-mock-provider': DEV_MOCK_PROVIDER_FIELD_IDS,
  'dev-mock-provider-alt': DEV_MOCK_PROVIDER_ALT_FIELD_IDS,
  'dev-mock-provider-no-siren': DEV_MOCK_PROVIDER_NO_SIREN_FIELD_IDS,
};

export const getProfileImportFieldIdsForConnection = (connectionId: string): readonly string[] =>
  FIELDS_BY_CONNECTION_ID[connectionId] ?? [];

export const getProfileImportFieldLabel = (fieldId: string): string => {
  switch (fieldId) {
    case 'identity.legal_name':
      return __('Raison sociale');
    case 'identity.siren':
      return __('SIREN');
    case 'identity.siret':
      return __('SIRET');
    case 'identity.vat_number':
      return __('Numéro de TVA');
    case 'identity.legal_form':
      return __('Forme juridique');
    case 'identity.nace_codes':
      return __('Codes NAF / NACE');
    case 'contact.email':
      return __('Email');
    case 'contact.phone':
      return __('Téléphone');
    case 'address.headquarters.line1':
      return __('Adresse (ligne 1)');
    case 'address.headquarters.line2':
      return __('Adresse (ligne 2)');
    case 'address.headquarters.postal_code':
      return __('Code postal');
    case 'address.headquarters.city':
      return __('Ville');
    case 'address.headquarters.country':
      return __('Pays');
    case 'fiscal.year_start':
      return __('Début exercice fiscal');
    case 'fiscal.year_end':
      return __('Fin exercice fiscal');
    default:
      return fieldId;
  }
};
